import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-content-dropdown',
  templateUrl: './formly-content-dropdown.component.html',
  styleUrls: ['./formly-content-dropdown.component.scss'],
})
export class FormlyContentDropdownComponent extends FieldType {
  getChain(fieldKey, model) {
    return fieldKey.split('.').reduce((cur, i) => cur[i], model)
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
